import { Role } from '@shared/models/entities/roles.model';

/**
 * Nombre del rol que administra el sistema. Es el que siembra
 * `seed_modulos_permisos.sql` (`v_rolName := 'Administrador Epione'`).
 */
export const EPIONE_ADMIN_ROLE = 'Administrador Epione';

/**
 * ¿Este rol es el de Administrador Epione?
 *
 * Se compara normalizado (sin acentos, sin mayúsculas y sin espacios de más)
 * porque el nombre del rol se captura a mano desde la pantalla de Roles y en
 * la base conviven variantes: "Administrador Epione", "ADMINISTRADOR EPIONE",
 * "Administrador epione ".
 *
 * Es el único criterio de "superusuario" del módulo de Soporte:
 *   · Tickets:  ve todos, y es el único con acciones (horas y estado).
 *   · Manuales: ve y edita todos los roles; los demás solo el suyo.
 */
export function isEpioneAdmin(role: Role | null | undefined): boolean {
  if (!role?.name) return false;
  return normalize(role.name) === normalize(EPIONE_ADMIN_ROLE);
}

function normalize(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')   // quita acentos
    .trim()
    .replace(/\s+/g, ' ')
    .toUpperCase();
}
